import { apiClient } from '../apiClient';

export interface ProfileSummaryCounts {
  completed: number;
  total: number;
}

export interface ProfileSummaryAttendance {
  pct: number;
  attended: number;
  total: number;
}

export interface ProfileSummaryStreak {
  current: number;
  longest: number;
}

export interface ProfileSummaryLearningSnapshot {
  modules: ProfileSummaryCounts;
  topics: ProfileSummaryCounts;
  assignments: ProfileSummaryCounts;
  assessments: ProfileSummaryCounts;
}

export interface ProfileSummary {
  current_batch: { id: string; name: string };
  enrolled_at: string | null;
  progress_pct: number;
  attendance: ProfileSummaryAttendance;
  streak: ProfileSummaryStreak;
  learning_snapshot: ProfileSummaryLearningSnapshot;
}

export const profileSummaryApi = {
  get: () => apiClient.get<ProfileSummary>('/api/v1/lms/profile-summary'),
};
